<a
  routerLink="{{ docuRoot }}/templates/{{ folder.id }}"
  class="docu-folder-{{ folder.color }}"
  >{{ folder.name }}</a
>
